import React from 'react'
import styled from '@emotion/styled'
import EdcLoader from '../components/EdcLoader/EdcLoader'

// Branded full-screen loader — gradient backdrop matches the
// DivisionSelector / Sidebar so the route-transition feels seamless.
const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #1e272e 0%, #2d3436 40%, #0a3d62 100%);
  overflow: hidden;
  margin: 0;
  padding: 0;
  z-index: 9999;
  /* Mount fade-in — prevents jarring snap-to-loader on auth hand-off. */
  animation: loading-fade-in 320ms cubic-bezier(0.22, 1, 0.36, 1) both;
  isolation: isolate;

  &::before {
    content: '';
    position: absolute;
    inset: -20% -20% auto auto;
    width: 60vmax;
    height: 60vmax;
    background: radial-gradient(circle at 30% 30%, rgba(116, 185, 255, 0.18), transparent 60%);
    pointer-events: none;
    z-index: 0;
    animation: loading-ambient 14s ease-in-out infinite alternate;
  }

  @keyframes loading-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes loading-ambient {
    0% {
      transform: translate3d(0, 0, 0) scale(1);
      opacity: 0.7;
    }
    100% {
      transform: translate3d(-6%, 4%, 0) scale(1.15);
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;

    &::before {
      animation: none;
    }
  }
`

const Loading = () => (
  <LoadingWrapper>
    <EdcLoader size="large" variant="light" label="Loading…" />
  </LoadingWrapper>
)

export default Loading
